import {createFileRoute} from '@tanstack/react-router'

import {WorkersPage} from '../../../assets/workers/workers-page'

export const Route = createFileRoute('/_app/workers/')({
    component: WorkersIndexRoute,
})

function WorkersIndexRoute() {
    return <WorkersPage />
}
